import Api from './axios'
import { baseURL } from '@/api/IPconfig'


const apiURL = {
    
    /* 登录 */
    randomCode: '/websit/sit/randomCode', // 获取验证码
    loginAuth: '/websit/sit/auth', // 密码登录

    /* 退出 */
    passwdRenewal: '/staff-sys/renewal', // 令牌续期
    passwdLogout: '/staff-sys/logout', // 退出

    uploadGet: '/fs/rtf/get', // 单个文件获取
    fileDownload: '/fs-sys/get/', // 文件下载  /fs-sys/get/{bucket}
    /* 
        /fs-sys/put/{bucket}  /fs-sys/get/{bucket}
        气氛业务bucket=kav-aio
        认证业务bucket=media-auth
        礼品业务bucket=kim-gift
        梗弹幕业务bucket=kim-args
     */
    websitQuery:'/websit/sit/query',//查看公告声明
    
}

export default {
    uploadAdd (params) {
        return baseURL.seeHouseClientService + apiURL.uploadAdd;
    },

    
    /**
    * @description  GET
    */
    uploadGet (params) {
        return Api.get(apiURL.uploadGet, params)
    },
    randomCode (params) {
        return Api.get(apiURL.randomCode, params,true)
    },
    fileDownload (fileId='',media='media-auth') {
        return baseURL.seeHouseClientService + apiURL.fileDownload+ media + '?fileId='+fileId;;
    },
    
    /**
    * @description  POST
    */
    loginAuth (params) {
        return Api.post(apiURL.loginAuth, params,true)
    },
    websitQuery (params) {
        return Api.post(apiURL.websitQuery, params)
    },
}
